import router from "./"
import store from "../store"

router.beforeEach((to, _, next) => {
    if (store.state.security.isLoggedIn === false) {
        store.dispatch("security/loginStatus").then(() => routeguard(to, next))
    } else {
        routeguard(to, next)
    }
})

router.afterEach(() => {
    window.scrollTo(0, 0)
})

function routeguard(to, next) {
    const isLoggedIn = store.state.security.isLoggedIn
    const mustChangePassword = store.state.security.requiresPasswordChange

    if (!isLoggedIn) {
        return to.name === "Login" ? next() : next({ name: "Login" })
    }

    if (mustChangePassword && to.name !== "ChangePassword") {
        return next({ name: "ChangePassword" })
    }

    if (!mustChangePassword && to.name === "Login") {
        return next({ name: "Layout" })
    }

    next()
}
